import { render, staticRenderFns } from "./add-template.vue?vue&type=template&id=62f11c47"
import script from "./add-template.vue?vue&type=script&lang=js"
export * from "./add-template.vue?vue&type=script&lang=js"
import style0 from "./add-template.vue?vue&type=style&index=0&id=62f11c47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports